module.exports = __webpack_public_path__ + "static/media/hide.png.d406da31.webp";